<template>
  <div class="custom-audience">
    <div class="region">
      <p class="level-2">
        地域
        <el-popover placement="top" trigger="hover" width="270">
          <div>
            <p class="t-tip">将广告投放至指定省市、区县的人群</p>
            <p class="t-tip">-正在：近期在该地的用户</p>
            <p class="t-tip">-居住：在长时间内常驻在该地区的用户</p>
            <p class="t-tip">-旅行：近期在该地，但非常驻的用户</p>
            <p class="t-tip">-所有：旅行+居住+正在该地区的所有用户</p>
          </div>
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </p>
      <el-radio-group
        v-model="form.audience.region"
        size="medium"
        @change="form.audience.regionArr = []"
      >
        <el-radio-button label="不限"></el-radio-button>
        <el-radio-button label="按省市"></el-radio-button>
        <el-radio-button label="按区县" v-if="!collapse"></el-radio-button>
      </el-radio-group>

      <div class="area-container" v-show="form.audience.region != '不限'">
        <div class="search-frame">
          <template v-if="form.audience.region == '按省市'">
            <div class="city-search">
              <el-input
                size="small"
                placeholder="省市搜索不支持按拼音、拼音首字母"
                prefix-icon="el-icon-search"
                v-model="regionSearch"
              >
              </el-input>
            </div>
            <el-tabs v-model="activeName">
              <el-tab-pane label="地理划分" name="1">
                <select-panel
                  :key="activeName"
                  :form="form"
                  :citys="citys"
                  title="省份"
                />
              </el-tab-pane>
              <el-tab-pane label="发展划分" name="2">
                <select-panel
                  :key="activeName"
                  :form="form"
                  :citys="citys"
                  title="等级"
                />
              </el-tab-pane>
            </el-tabs>
          </template>
          <select-panel
            v-else
            :key="activeName"
            :form="form"
            :citys="citys"
            title="省份"
          />
        </div>
        <div class="location-type">
          <el-radio-group v-model="form.audience.audienceType">
            <el-radio label="正在该地区的用户"></el-radio>
            <el-radio label="居住在该地区的用户"></el-radio>
            <el-radio label="到该地区旅游的用户"></el-radio>
            <el-radio label="该地区内的所有用户"></el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>

    <div class="collapse-more" v-show="moreSetting || !collapse">
      <div class="sex">
        <p class="level-2">
          性别
          <el-popover placement="top" trigger="hover">
            <p style="font-size: 12px">
              通过字节跳动旗下app数据，模型算法预测的用户性别
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <el-radio-group v-model="form.audience.sex" size="medium">
          <el-radio-button label="不限"></el-radio-button>
          <el-radio-button label="男"></el-radio-button>
          <el-radio-button label="女"></el-radio-button>
        </el-radio-group>
      </div>

      <div class="age">
        <p class="level-2">
          年龄
          <el-popover placement="top" trigger="hover">
            <p style="font-size: 12px">
              通过字节跳动旗下app数据，模型算法预测的用户年龄区间
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <span
          class="bx"
          :class="{ active: form.audience.age.length == 0 }"
          @click="form.audience.age = []"
          >不限</span
        >
        <el-checkbox-group v-model="form.audience.age" size="medium">
          <el-checkbox label="18-23" border></el-checkbox>
          <el-checkbox label="24-30" border></el-checkbox>
          <el-checkbox label="31-40" border></el-checkbox>
          <el-checkbox label="41-49" border></el-checkbox>
          <el-checkbox label="50+" border></el-checkbox>
        </el-checkbox-group>
      </div>

      <behavioral-interest :form="form" v-if="showInterest" />

      <div class="talent" v-if="!isSearch">
        <p class="level-2">
          抖音达人
          <el-popover placement="top" trigger="hover">
            <p style="font-size: 12px">
              圈定单个或某类抖音号后，投放时会定向与该（类）账号的粉丝有相似互动行为的人群
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <el-radio-group v-model="form.audience.talent" size="medium">
          <el-radio-button label="不限"></el-radio-button>
          <el-radio-button label="自定义" disabled></el-radio-button>
        </el-radio-group>
        <p class="aweme-fans-tip-msg">
          通过选择抖音达人或达人所在分类，定向对这些内容感兴趣的用户
          <a
            href="https://bytedance.feishu.cn/docs/doccnHDVVWvOi44KxC8LTiVWMSc"
            target="_blank"
            rel="noopener noreferrer"
            >了解详情</a
          >
        </p>
      </div>

      <div class="network" v-if="isLive">
        <p class="level-2">网络</p>
        <span
          class="bx"
          :class="{ active: form.audience.network.length == 0 }"
          @click="form.audience.network = []"
          >不限</span
        >
        <el-checkbox-group v-model="form.audience.network" size="medium">
          <el-checkbox label="Wi-Fi" border></el-checkbox>
          <el-checkbox label="2G" border></el-checkbox>
          <el-checkbox label="3G" border></el-checkbox>
          <el-checkbox label="4G" border></el-checkbox>
        </el-checkbox-group>
      </div>

      <div class="platform" v-if="collapse || isLive">
        <p class="level-2">平台</p>
        <el-radio-group v-model="form.audience.platform" size="medium">
          <el-radio-button label="不限"></el-radio-button>
          <el-radio-button label="iOS"></el-radio-button>
          <el-radio-button label="安卓"></el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div
      class="collapse-header"
      v-if="collapse"
      @click="moreSetting = !moreSetting"
    >
      <i
        class="icon"
        :class="[
          moreSetting ? 'el-icon-d-arrow-left' : 'el-icon-d-arrow-right',
        ]"
      ></i>
      <span class="text">{{ moreSetting ? "收起" : "展开高级选项" }}</span>
    </div>
  </div>
</template>

<script>
import city from "@/utils/city";
import selectPanel from "./selectPanel.vue";
import BehavioralInterest from "./behavioralInterest.vue";
export default {
  components: { selectPanel, BehavioralInterest },
  props: {
    form: Object,
    isSearch: Boolean,
    collapse: Boolean,
    isLive: Boolean,
    showInterest: Boolean,
  },
  data() {
    return {
      city,
      regionSearch: "",
      activeName: "1",
      moreSetting: false,
    };
  },
  computed: {
    citys() {
      if (this.form.audience.region == "按省市") {
        if (this.activeName == "1") {
          return this.city.cityArr;
        } else {
          return this.city.cityLevel;
        }
      } else if (this.form.audience.region == "按区县") {
        return this.city.cityPca;
      }
    },
  },
  watch: {
    activeName() {
      this.form.audience.regionArr = [];
    },
  },
};
</script>

<style lang="less" scoped>
.custom-audience {
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
    .el-icon-question {
      margin-left: 3px;
      color: #d3d3d3;
      font-size: 16px;
      vertical-align: -1px;
      cursor: pointer;
    }
  }
  .region {
    width: 648px;
    .area-container {
      margin-top: 16px;
      padding: 0 16px;
      border: 1px solid rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      .search-frame {
        margin-top: 24px;
        .city-search {
          margin-bottom: 10px;
          ::v-deep .el-input {
            .el-input__inner {
              background-color: #f2f2f2;
            }
          }
        }
        ::v-deep .el-tabs {
          .el-tabs__nav-wrap {
            &::after {
              display: none;
            }
            .el-tabs__active-bar {
              background-color: #194ce5;
            }
            .el-tabs__item {
              height: 30px;
              line-height: 30px;
              color: #666;
              &.is-active {
                color: inherit;
                font-weight: bold;
              }
              &:hover {
                color: #333;
              }
            }
          }
        }
      }
      .location-type {
        margin-top: 24px;
        margin-bottom: 4px;
        ::v-deep  .el-radio {
          margin-bottom: 20px;
          .el-radio__inner {
            width: 16px;
            height: 16px;
          }
          &.is-checked {
            .el-radio__inner {
              border-color: #28304c;
              background: #fff;
              &::after {
                width: 8px;
                height: 8px;
                background-color: #28304c;
              }
            }
            .el-radio__label {
              color: inherit;
            }
          }
        }
      }
    }
  }
  .age,
  .network {
    .bx {
      display: inline-block;
      margin-right: 5px;
      padding-left: 15px;
      padding-right: 15px;
      width: 110px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;
      border-radius: 4px;
      vertical-align: top;
      cursor: pointer;
      &:hover {
        background-color: #eff0fe;
      }
      &.active {
        color: #194ce5;
        border: 1px solid #194ce5;
        background-color: #fff;
      }
    }
    ::v-deep .el-checkbox-group {
      display: inline-block;
      .el-checkbox {
        margin: 0 5px;
        min-width: 110px;
        height: 34px;
        background: #f2f2f2;
        border: 1px solid transparent;
        color: #333;
        &:hover {
          background-color: #eff0fe;
        }
        &.is-checked {
          color: #194ce5;
          border: 1px solid #194ce5;
          background-color: #fff;
          .el-checkbox__inner {
            background-color: #e0e7fc;
            border-color: #e0e7fc;
            &::after {
              border-color: #194ce5;
            }
          }
          .el-checkbox__label {
            color: #194ce5;
          }
        }
      }
    }
  }
  .talent {
    .aweme-fans-tip-msg {
      margin-top: 12px;
      font-size: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.6);
      a {
        color: #3751ff;
        margin-left: 8px;
      }
    }
  }
  .collapse-header {
    display: inline-block;
    margin-top: 25px;
    cursor: pointer;
    .icon {
      margin-right: 8px;
      transform: rotate(90deg);
      font-weight: bold;
    }
    .text {
      letter-spacing: 2px;
    }
  }
  ::v-deep  .el-radio-group {
    .el-radio-button__inner {
      padding-left: 15px;
      padding-right: 15px;
      min-width: 100px;
      height: 34px;
      background: #f2f2f2;
      border: 1px solid transparent;
      color: #333;
      // border-radius: 4px;
      &:hover {
        background-color: #eff0fe;
      }
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #194ce5;
      border: 1px solid #194ce5;
      background-color: #fff;
      box-shadow: none;
    }
  }
}
</style>
<style lang="less">
.t-tip {
  font-size: 12px;
  line-height: 2;
}
</style>